export default __webpack_public_path__ + "media/images/instagram-header-social-7af21df3c9193a744b24c69d41e5afaa.svg";